import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { actionDefintion, actionInfo } from '@shared/utils/SimpleActionManager';

@Component({
	selector: 'app-action-menu-element',
	templateUrl: './actionmenuelement.component.html',
	styleUrls: ['./actionmenuelement.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ActionMenuElement {
	@Input()
	public action: actionInfo<any>;

	@Output()
	public actionClick: EventEmitter<any> = new EventEmitter<any>();

	emitSelectAction(arg0: actionDefintion<any>) {
		this.actionClick.emit(arg0);
	}
}
